<template>
  <div class="home">
    <Navbar />
    <home-banner />
    <!-- <Section title="How BEX Works?" small-text="Learn how to start selling on BEX." component-name="HowWorksContent" /> -->
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from '../components/Navbar.vue'
import HomeBanner from '../components/banners/HomeBanner.vue'
// import Section from '../components/Section.vue'
import Footer from '../components/Footer.vue'

export default {
  name: 'Home',
  components: {
    Navbar,
    HomeBanner,
    // Section,
    Footer
  }
}
</script>
